const newLoanRoutePrefix = '/nylan';

const newLoanRouteObject = [
  { name: 'ADDRESS', path: '/adresse/:uid' },
  { name: 'ADDRESS_ABROAD', path: '/adresse-utland/:uid' },
  { name: 'BUDGET', path: '/budsjett/:uid' },
  { name: 'CAR', path: '/bil/:uid' },
  { name: 'CHILDREN', path: '/barn/:uid' },
  { name: 'CHILD_SUPPORT', path: '/barnetrygd/:uid' },
  { name: 'CO_APPLICANT_LANDING', path: '/medsoker-login/:uid' },
  { name: 'CO_APPLICANT_STATUS', path: '/medsoker-status/:uid' },
  { name: 'CONTINUE_APPLICATION', path: '/fortsett-soknad/:uid' },
  { name: 'CREDIT_CARD_OFFER', path: '/kredittkorttilbud/:uid' },
  { name: 'DEBT', path: '/gjeld/:uid' },
  { name: 'EQUITY', path: '/egenkapital/:uid' },
  { name: 'HOUSE_SUMMARY', path: '/boligoppsummering/:uid' },
  { name: 'INCOME', path: '/inntekt/:uid' },
  { name: 'INIT_APPLICATION', path: '/init' },
  { name: 'JOINT_DEBT', path: '/felles-gjeld/:uid' },
  { name: 'LOCATION', path: '/lokasjon/:uid' },
  { name: 'LOCATION_ABROAD', path: '/lokasjon-utland/:uid' },
  { name: 'INCOME_DEBT_SUMMARY', path: '/inntekt-gjeld-oppsummering/:uid' },
  { name: 'INTRO', path: '/' },
  { name: 'INTRO_APPLICANT_INFO', path: '/litt-om-deg/:uid' },
  { name: 'INTRO_WITH_UID', path: '/:uid' },
  { name: 'JOB_SITUATION', path: '/jobbsituasjon/:uid' },
  { name: 'MARITAL_STATUS', path: '/sivilstatus/:uid' },
  { name: 'NORDVIK_LANDING', path: '/nordvik/:uid' },
  { name: 'OTHER_DEBTS_PAGE', path: '/andre-gjeld/:uid' },
  { name: 'PARTNER_INIT_APPLICATION', path: '/partner/:uid' },
  { name: 'PEP', path: '/pep/:uid' },
  { name: 'PRICE', path: '/pris/:uid' },
  { name: 'PROCESS_TYPE', path: '/prosess/:uid' },
  { name: 'PROPERTY_TYPE', path: '/boligtype/:uid' },
  { name: 'SBL_CONSENT', path: '/sbl-samtykke/:uid' },
  { name: 'SBL_CONSENT_DENIED', path: '/ingen-sbl-samtykke/:uid' },
  { name: 'SUBMIT', path: '/send-inn/:uid' },
  { name: 'SUCCESS', path: '/suksess/:uid' },
  { name: 'YOUR_INFORMATION', path: '/din-informasjon/:uid' },
] as const;

export type NewLoanPage = (typeof newLoanRouteObject)[number]['name'];

export const newLoanPageToRoute: Record<NewLoanPage, string> =
  Object.fromEntries(
    newLoanRouteObject.map(({ name, path }) => [
      name,
      newLoanRoutePrefix + path,
    ]),
  ) as Record<NewLoanPage, string>;
